import React from "react";
import { createPortal } from "react-dom";


function ModalWrapper({
  onClose,
  children,
    closeOnBackdropClick = false,
}) {
  return createPortal(
   <div
      className="fixed inset-0 flex items-center justify-center bg-blue-500/40 z-[1000]"
      onClick={closeOnBackdropClick ? onClose : undefined}
    >
      {children}
  </div>,
  document.body
  );
}

export default ModalWrapper;

/*
<ModalWrapper onClose={closeTopModal}>
  <FrmMenusProp onClose={closeTopModal} />
</ModalWrapper>



 return createPortal(
    <div className="modal-backdrop">
    
       {children}
        
    </div>,
    document.body
  );
*/